import type { SVGProps } from 'react'

export const EyeClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 67 27' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M63.5 2C63.5 2 56.5 23.5 34 23.5C11.5 23.5 3 2 3 2'
      strokeWidth='6'
      fill='none'
    />
  </svg>
)

EyeClosed.toString = () => 'eye-closed'
